import { createContext, useContext } from 'react';

export interface EventPlanType {
  id: string;
  startDate?: Date;
  startOffset?: number;
  endOffset?: number;
  location?: string;
  groupSize?: number;
  name?: string;
  collaborators: {
    id: string;
    email: string;
    fullName?: string;
    gravatarUrl?: string;
  }[];
  invitations: {
    id: string;
    inviteeEmail: string;
  }[];
  guest: {
    email?: string;
  };
  events: {
    id: string;
    inquiryStatus?: string;
    createdAt: Date;
    venueRespondedAt?: Date;
    planner: {
      fullName?: string;
    };
    venue: {
      id: string;
      name: string;
      pathname: string;
      logo?: string;
    };
    spaces: {
      name: string;
      pathname: string;
      id: string;
      images: {
        url: string;
      }[];
    }[];
    slug: string;
  }[];
}

export const EventPlanContext = createContext<{
  eventPlan: EventPlanType;
}>({
  eventPlan: {
    id: '',
    startOffset: 0,
    endOffset: 0,
    location: '',
    groupSize: 0,
    name: '',
    collaborators: [],
    invitations: [],
    events: [],
    guest: {
      email: '',
    },
  },
});

export const useEventPlan = () => {
  return useContext(EventPlanContext);
};
